import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './global.css';
import App from './App';
import { Routes, Route, HashRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { HistoryProvider } from './context/HistoryContext';
import { LanguageProvider } from './context/LanguageProvider';

require('./i18n')

const queryclient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    }
  }
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <QueryClientProvider client={queryclient}>
    <HashRouter basename='/'>
      <LanguageProvider>
        <HistoryProvider>
          <AuthProvider>
            <Routes>
              <Route path="/*" element={<><App /></>} />
            </Routes>
          </AuthProvider>
        </HistoryProvider>
      </LanguageProvider>
    </HashRouter>
    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
  </QueryClientProvider>
);